export default __webpack_public_path__ + "static/media/stiwi.e8aeb48c.jpg";